import { render, staticRenderFns } from "./c_data_detail.vue?vue&type=template&id=2edd5aa1&scoped=true&"
import script from "./c_data_detail.vue?vue&type=script&lang=js&"
export * from "./c_data_detail.vue?vue&type=script&lang=js&"
import style0 from "./c_data_detail.vue?vue&type=style&index=0&id=2edd5aa1&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2edd5aa1",
  null
  
)

export default component.exports